/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Parking_SpacesInputs */

const en_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parking Spaces`)
};

const es_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plazas de aparcamiento`)
};

const fr_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places de parking`)
};

const de_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parkplätze`)
};

const ja_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`駐車スペース`)
};

const zh_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`停车位`)
};

const ar_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواقف السيارات`)
};

const id_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area Parkir`)
};

const it_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posti Auto`)
};

const ru_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Парковочные места`)
};

const pt_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vagas de Garagem`)
};

const ko_field_parking_spaces = /** @type {(inputs: Field_Parking_SpacesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주차 대수`)
};

/**
* | output |
* | --- |
* | "Parking Spaces" |
*
* @param {Field_Parking_SpacesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_parking_spaces = /** @type {((inputs?: Field_Parking_SpacesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Parking_SpacesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_parking_spaces(inputs)
	if (locale === "es") return es_field_parking_spaces(inputs)
	if (locale === "fr") return fr_field_parking_spaces(inputs)
	if (locale === "de") return de_field_parking_spaces(inputs)
	if (locale === "ja") return ja_field_parking_spaces(inputs)
	if (locale === "zh") return zh_field_parking_spaces(inputs)
	if (locale === "ar") return ar_field_parking_spaces(inputs)
	if (locale === "id") return id_field_parking_spaces(inputs)
	if (locale === "it") return it_field_parking_spaces(inputs)
	if (locale === "ru") return ru_field_parking_spaces(inputs)
	if (locale === "pt") return pt_field_parking_spaces(inputs)
	return ko_field_parking_spaces(inputs)
});